import type { OrderBookableTimeChangeSocketEvent } from "./order-bookable-time-change.socket-event";
import type { OrderCancelledSocketEvent } from "./order-cancelled.socket-event";
import type { OrderChangedSocketEvent } from "./order-changed.socket-event";
import type { OrderCommentedSocketEvent } from "./order-commented.socket-event";
import type { OrderConfirmedSocketEvent } from "./order-confirmed.socket-event";
import type { OrderCreatedSocketEvent } from "./order-created.socket-event";
import type { OrderFulfilledSocketEvent } from "./order-fulfilled.socket-event";
import type { OrderFulfillmentReversedSocketEvent } from "./order-fulfillment-reversed.socket-event";
import type { OrderOutForDeliverySocketEvent } from "./order-out-for-delivery.socket-event";
import type { OrderPayRequestFulfilledSocketEvent } from "./order-pay-request-fulfilled.socket-event";
import type { OrderPendingConfirmationSocketEvent } from "./order-pending-confirmation.socket-event";
import type { OrderPendingDeliverySocketEvent } from "./order-pending-delivery.socket-event";
import type { OrderPendingPaymentConfirmationSocketEvent } from "./order-pending-payment-confirmation.socket-event";
import type { OrderRefundedFulfilledSocketEvent } from "./order-refunded-fulfilled.socket-event";
import type { OrderRefundedSocketEvent } from "./order-refunded.socket-event";
import type { OrderRejectedSocketEvent } from "./order-rejected.socket-event";
import {
    orderSocketEventNamespace,
    orderSocketEventTypeNames,
} from "./order-socket-event-type-name";

type OrderSocketEvent =
    | OrderCancelledSocketEvent
    | OrderCommentedSocketEvent
    | OrderConfirmedSocketEvent
    | OrderCreatedSocketEvent
    | OrderFulfilledSocketEvent
    | OrderFulfillmentReversedSocketEvent
    | OrderOutForDeliverySocketEvent
    | OrderPendingConfirmationSocketEvent
    | OrderPendingDeliverySocketEvent
    | OrderPendingPaymentConfirmationSocketEvent
    | OrderRejectedSocketEvent
    | OrderRefundedSocketEvent
    | OrderRefundedFulfilledSocketEvent
    | OrderBookableTimeChangeSocketEvent
    | OrderPayRequestFulfilledSocketEvent
    | OrderChangedSocketEvent;

type OrderSocketEventType = OrderSocketEvent["type"];

const orderSocketEventTypes = orderSocketEventTypeNames.map(
    name => `${orderSocketEventNamespace}:${name}`,
) as OrderSocketEventType[];

export { orderSocketEventTypes };
export type { OrderSocketEvent, OrderSocketEventType };
